<template>
  <div :class="['bottom-menu-box', isDark ? 'theme-dark' : '']">
    <div class="menu-item" @click="handleClickMenu">
      <span class="nv-icon icon-menu"></span>
    </div>
    <div class="menu-item">
      <span @click="toggleReadMode" :class="['nv-icon', isDark ? 'icon-dark-night icon-dark' : 'icon-night']"></span>
    </div>
    <div class="menu-item">
      <span @click="handleClickSetting" class="nv-icon icon-setting"></span>
    </div>
    <!-- setting box -->
    <van-popup :lock-scroll="false" overlay-class="chapter-box-overlay" v-model="showSettings" position="bottom">
      <div class="setting-box">
        <div class="row font-setting-row">
          <div class="flex-center section">
            <div class="tag-box flex-center" @click="changeFontSize(-1)">A-</div>
            <div class="tag-box flex-center" @click="changeFontSize(1)">A+</div>
          </div>
          <div class="flex-center section tag-box">
            <template v-for="item in fonts">
              <div :key="item.name" :class="makeFontItemClass(item.value)" @click="changeFont(item)">Aa</div>
            </template>
          </div>
        </div>
        <div class="row bg-setting-row bg-settings" @click="changeBackground">
          <template v-for="item in colors">
            <div v-if="item.name === 'black'" :key="item.name" :class="makeBgItemClass(item)">
              <span :data-color-name="item.name" :data-color-value="item.value" class="nv-icon icon-dark-night"></span>
            </div>
            <div
              v-else
              :key="item.name"
              :class="makeBgItemClass(item)"
              :data-color-value="item.value"
              :data-color-name="item.name"
            ></div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const colors = [
  { name: "black", value: "#282c2f" },
  { name: "white", value: "#f8f8f9" },
  { name: "green", value: "#F0FBF7" },
  { name: "yellow", value: "#FFFBF6" }
];

export default {
  data() {
    this.fonts = [
      { name: "roboto", value: "ROBOTO" },
      { name: "poly", value: "POLY" }
    ];
    return {
      showSettings: false,
      colors
    };
  },
  methods: {
    handleClickMenu() {
      window.$event("ReadMenu_ChapterList_Click", {});
      this.$emit("click-menu");
    },
    toggleReadMode() {
      if (!this.isDark) {
        window.$event("ReadMenu_NightMode_Click", {});
      }
      this.$store.commit("TOGGLE_READ_MODE");
      this.$store.commit("SET_BACKGROUND", {});
    },
    handleClickSetting() {
      window.$event("ReadMenu_Setting_Click", {});
      this.showSettings = true;
    },
    changeBackground(e) {
      const { colorName, colorValue } = e.target.dataset;
      colorName !== "black" &&
        window.$event("ReadMenu_Setting_BackgroundSwitch_Click", {
          color: colorName
        });
      if (colorName && colorValue) {
        const color = { name: colorName, value: colorValue };
        const mode = color.name === "black" ? "DARK" : "LIGHT";
        this.$store.commit("TOGGLE_READ_MODE", mode);
        this.$store.commit("SET_BACKGROUND", color);
      }
    },
    changeFont(item) {
      window.$event("ReadMenu_Setting_FrontSwitch_Click", { font: item.value });
      this.$store.commit("SET_FONT", item.value);
    },
    changeFontSize(tag) {
      this.$store.commit("SET_FONTSIZE", tag);
    },
    makeFontItemClass(tag) {
      const base = ["flex-center", "tag-box", "tag-item"];
      if (tag === "POLY") {
        base.push("poly-font");
      }
      if (this.font === tag) {
        base.push("tag-item-active");
      }
      return base.join(" ");
    },
    makeBgItemClass(item) {
      const storedBg = this.$store.state.background || {};
      const base = ["bg-item", "flex-center", item.name];
      if (item.name === storedBg.name) {
        base.push("active");
      }
      return base.join(" ");
    }
  },
  computed: {
    isDark() {
      return this.$store.state.readMode === "DARK";
    },
    font() {
      return this.$store.state.font || "ROBOTO";
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-menu-box {
  &.theme-dark {
    background: $bg-menu-d;
    .setting-box {
      background: $bg-menu-d;
    }
  }
  position: fixed;
  bottom: 0;
  height: $bottom-menu-height;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: $bg-menu;
  .menu-item {
    .nv-icon {
      font-size: 24px;
      color: $fc-icon-grey;
    }
    .icon-dark {
      color: $color-main;
    }
  }
  .setting-box {
    padding: 24px;
    .row {
      display: flex;
      justify-content: space-around;
      .section {
        flex: 1;
        justify-content: space-around;
      }
      .tag-box {
        height: 32px;
        width: 35%;
        border-radius: 16px;
        background: $bg-main;
        color: $fc-icon-grey;
      }
      .tag-item {
        height: 24px;
      }
      .tag-item-active {
        background: white;
        color: $color-main;
      }
      &.bg-settings {
        margin-top: 20px;
        .bg-item {
          width: 34px;
          height: 34px;
          border-radius: 50%;
        }
        .black {
          border: 2px solid #292c2f;
          background: #292c2f;
          color: #7b8085;
        }
        .white {
          border: 2px solid #e5e5ea;
          background: #f8f8f9;
        }
        .green {
          background: #f0fbf7;
          border: 2px solid #b4ddce;
        }
        .yellow {
          background: #fffbf6;
          border: 2px solid #fadebb;
        }
        .active {
          border: 2px solid $color-main;
        }
      }
    }
  }
}
</style>
